<form id="editAlertVolumeForm">
  <dialog-header>Control Alert Volume</dialog-header>
  <mat-dialog-content>
    <div class="tw-flex tw-flex-col tw-gap-[15px]">
      <!-- Description and Toggle -->
      <div
        class="tw-flex tw-flex-row tw-items-start tw-justify-between tw-gap-2.5"
      >
        <div class="tw-flex-1">
          Set the display volume for CAP Alerts. The previous volume will be
          restored when the alert ends. On Chrome OS, this works only with LG
          screens connected by an RS-232 cable.
        </div>
        <mat-slide-toggle
          id="volumeControlSupported"
          name="volumeControlSupported"
          [(ngModel)]="model.settings.volumeControlSupported"
          (ngModelChange)="onVolumeControlToggle($event)"
        />
      </div>

      <!-- Volume Slider -->
      <div class="tw-flex tw-flex-row tw-items-center tw-gap-2.5">
        <mat-slider
          min="0"
          max="100"
          step="1"
          color="accent"
          aria-label="Volume control"
          class="tw-flex-1"
        >
          <input
            matSliderThumb
            [(value)]="volumePercentage"
            (valueChange)="onVolumeChange($event)"
            aria-label="Volume percentage"
          />
        </mat-slider>
        <mat-form-field appearance="outline" class="volume-input">
          <input
            matInput
            type="number"
            name="volumePercentage"
            [min]="0"
            [max]="100"
            [(ngModel)]="volumePercentage"
            (input)="onVolumeInputChange($event)"
            class="tw-text-center"
          />
        </mat-form-field>
      </div>

      <div class="madero-style alert alert-info tw-border-0">
        <div class="tw-flex tw-items-start tw-gap-[7.5px]">
          <mat-icon
            svgIcon="info"
            class="tw-text-blue-600"
            aria-hidden="true"
          ></mat-icon>
          <span class="tw-flex-1" style="color: initial">
            Audio will only play if it's enabled in your
            <a
              uiSref="apps.settings.integrations.open"
              [uiParams]="{ integrationId: 'cap-alerts' }"
              class="madero-link"
              target="_blank"
              rel="noopener noreferrer"
              >CAP Alert settings</a
            >.
          </span>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="tw-gap-2.5">
    <button rv-button variant="secondary" type="button" (click)="onCancel()">
      Cancel
    </button>
    <button rv-button type="button" (click)="onApply()">Confirm</button>
  </mat-dialog-actions>
</form>
